import { api } from "../api";

// Asks the API whether the buyer must fill in the address. The API never returns
// the saved address (LGPD), only the flag. Any failure falls back to asking for
// the address, since the API accepts it in every case.
export const useAddressRequirement = checkoutId => {
  const checkAddressRequirement = async (email, docNumber) => {
    try {
      const { data } = await api.post(
        `checkout/${checkoutId}/address_requirement`,
        { email, doc_number: docNumber }
      );

      return data?.address_required !== false;
    } catch (error) {
      return true;
    }
  };

  return { checkAddressRequirement };
};
